/* eslint-disable no-imports/outside-special-folder */
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router';

import { useTranslation } from 'app/lang';
import { getBackendServerUrl } from 'app/ssr/utils';

import dictionary from './Seo.dictionary.json';

export const SeoKomyob = () => {
  const { t, lang } = useTranslation();
  const { pathname } = useLocation();

  return (
    <Helmet>
      <html lang={lang} />

      <meta name="viewport"
            content="width=device-width, initial-scale=1" />

      <title>{t(dictionary.titleKomyob)}</title>

      <meta
        name="description"
        content={t(dictionary.descriptionKomyob)} />

      <meta
        name="keywords"
        content="" />

      <meta name="robots"
            content="index, follow" />

      <meta name="google-site-verification"
            content="7evmGdrqW4r5Pf1SPuwsGP3EmH6jDzcoNHfrN-5KrMI" />

      <meta
        name="application-name"
        content={t(dictionary.contentKomyob)} />

      <meta
        name="apple-mobile-web-app-title"
        content={t(dictionary.contentKomyob)} />

      <meta name="msapplication-TileImage"
            content={`${getBackendServerUrl()}images/favicon.svg`} />

      <meta
        name="msapplication-tooltip"
        content={t(dictionary.contentKomyob)} />

      <meta name="author"
            content={t(dictionary.contentKomyob)} />

      <meta name="copyright"
            content={getBackendServerUrl()} />

      <meta property="og:type"
            content="website" />

      <meta
        property="og:title"
        content={t(dictionary.contentKomyob)} />

      <meta property="og:url"
            content={getBackendServerUrl()} />

      <meta property="og:image"
            content={`${getBackendServerUrl()}/images/apple-touch-icon.png`} />

      <meta
        property="og:description"
        content={t(dictionary.descriptionKomyob)} />

      <link rel="canonical"
            href={`${getBackendServerUrl()}${pathname}`} />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: `{ "@context": "http://schema.org/", "@type": "WebSite", "url": "${getBackendServerUrl()}", "potentialAction":

{ "@type": "SearchAction", "target": "[${getBackendServerUrl()}/?search?q=\{search_term_string}
]", "query-input": "required name=search_term_string" } }`,
        }} />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: `{ "@context": "http://schema.org/", "@type": "Product", "name": "${getBackendServerUrl()}", "image": "${getBackendServerUrl()}images/apple-touch-icon.png", "description": {t(dictionary.descriptionKomyob)}, "brand":

          { "@type": "Brand", "name": "komyob" }
          , "offers":

          { "@type": "AggregateOffer", "priceCurrency": "TJS", "lowPrice": "10", "highPrice": "15000", "url": "[${getBackendServerUrl()}live]", "availability": "[https://schema.org/InStock]", "offerCount": "10" }
          , "aggregateRating":

          { "@type": "AggregateRating", "ratingValue" : "5", "ratingCount" : "15", "reviewCount" : "14", "worstRating" : "1", "bestRating" : "4" }
          , "review": [ { "@type": "Review", "name" : "Лучшая букмекерская компания в тч", "author":

          { "@type": "Person", "name": "Сергей" }
          , "datePublished": "2024-05-10", "reviewBody" : "Отличный бк. Тут есть мини игры но и эксклюзивная линия хорошо расписана", "reviewRating":

          { "@type": "Rating", "ratingValue" : "4", "worstRating" : "1", "bestRating" : "5" }
          }, { "@type": "Review", "name" : "Выплаты", "author":

          { "@type": "Person", "name": "Джар" }
          , "datePublished": "2024-05-17", "reviewBody" : "Выплаты идут, вроде все ок", "reviewRating":

          { "@type": "Rating", "ratingValue" : "5", "worstRating" : "1", "bestRating" : "5" }
          } ] } `,
        }} />
    </Helmet>
  );
};
